/*
 * @Description: Description
 * @Author: ranli
 * @Date: 2024-07-16 15:53:59
 * @LastEditTime: 2026-04-23 11:28:41
 * @LastEditors: ranli
 */
// 定义路由，每个路由都需要映射到一个组件
import AppLayout from '@/layouts/AppLayout.vue'

export function getRouter() {
  return [
    {
      path: '/',
      component: AppLayout,
      redirect: { name: 'Home' },
      children: [
        {
          path: 'home',
          name: 'Home',
          component: () => import('@/views/home/index.vue'),
          meta: {
            title: 'Home',
            layout: 'tab',
            keepAlive: true,
            tabBar: true,
          },
        },
        {
          path: 'matches',
          name: 'Matches',
          component: () => import('@/views/matches/index.vue'),
          meta: {
            title: 'My Matches',
            layout: 'tab',
            keepAlive: true,
            tabBar: true,
          },
        },
        {
          path: 'rewards',
          name: 'Rewards',
          component: () => import('@/views/rewards/index.vue'),
          meta: {
            title: 'Rewards',
            layout: 'tab',
            keepAlive: true,
            tabBar: true,
          },
        },
        // 普通内页（有 header，无 tabbar）
        {
          path: 'rules/detail/:tab?',
          name: 'RulesDetail',
          component: () => import('@/views/rules/detail.vue'),
          meta: {
            title: 'Point System',
            layout: 'inner',
            keepAlive: true,
          },
        },
        {
          path: 'contest/:mid/:tabName?',
          name: 'ContestDetail',
          component: () => import('@/views/contests/index.vue'),
          meta: {
            title: 'Contest Details',
            layout: 'inner',
            keepAlive: true,
            showPts: true,
          },
        },
        {
          path: 'myContest/:mid/:roomId/:tabName?',
          name: 'MyContestDetail',
          component: () => import('@/views/myContestDetail/index.vue'),
          meta: {
            title: 'My Contest Details',
            layout: 'inner',
            showPts: true,
            keepAlive: true,
          },
        },
        {
          path: 'room/:mid/:templateId/:roomId?',
          name: 'RoomDetail',
          component: () => import('@/views/contestDetail/index.vue'),
          meta: {
            title: 'Room Details',
            layout: 'inner',
            showPts: true,
            keepAlive: false,
          },
        },
        {
          path: 'team/edit/:mid/:tid?',
          name: 'EditMyTeam',
          component: () => import('@/views/team/editMyTeam/index.vue'),
          meta: {
            title: 'Create Team',
            layout: 'inner',
            showPts: true,
            keepAlive: false,
          },
        },
        {
          path: 'team/vc',
          name: 'EditMyTeamVC',
          component: () => import('@/views/team/editMyTeamVC/index.vue'),
          meta: {
            title: 'Choose Captain',
            showPts: true,
            layout: 'inner',
            keepAlive: false,
          },
        },
        // 球员积分详情页面
        {
          path: 'player/score/:userTeamId/:playerId?/:mid?',
          name: 'PlayerScoreDetail',
          component: () => import('@/views/player/PlayerScoreDetail/index.vue'),
          meta: {
            title: 'Player Info',
            layout: 'inner',
            showPts: true,
            keepAlive: false,
          },
        },
        {
          path: 'game-history',
          name: 'GameHistory',
          component: () => import('@/views/gameHistory/index.vue'),
          meta: {
            title: 'My Transactions',
            layout: 'inner',
            showPts: true,
            keepAlive: false,
          },
        },
        {
          path: 'typeroom-list',
          name: 'TypeRoomList',
          component: () => import('@/views/typecontests/index.vue'),
          meta: {
            title: 'Contest',
            layout: 'inner',
            showPts: false,
            keepAlive: true,
          },
        },
      ],
    },
    // {
    //   path: '/:pathMatch(.*)*',
    //   name: 'NotFound',
    //   // component: error,
    //   meta: {
    //     title: 'NotFound',
    //   },
    // }
  ]
}
